export function getStatusColorClassName(status: string) {
  switch (status.toLowerCase()) {
    case 'complete':
    case 'filled':
    case 'success':
    case 'sl-success':
    case 'registered':
    case 'completed':
      return 'text-brand-green-dark bg-brand-tertiary-green'
    case 'pending':
    case 'paused':
    case 'in progress':
    case 'sl-pending':
    case 'queued':
    case 'new':
    case 'modified':
      return 'text-brand-yellow-chileanFire bg-brand-tertiary-orange'
    case 'failed':
    case 'sl-failed':
    case 'rejected':
      return 'text-brand-red-carnation bg-brand-tertiary-red'
    case 'cancelled':
    default:
      return 'text-brand-grey-base bg-brand-grey-background'
  }
}

export function getTextColorClassName(status: string) {
  switch (status.toLowerCase()) {
    case 'complete':
    case 'filled':
    case 'success':
    case 'sl-success':
    case 'registered':
    case 'completed':
      return 'text-brand-green-dark'
    case 'pending':
    case 'paused':
    case 'in progress':
    case 'sl-pending':
    case 'queued':
    case 'new':
    case 'modified':
      return 'text-brand-yellow-chileanFire'
    case 'failed':
    case 'sl-failed':
    case 'rejected':
      return 'text-brand-red-carnation'
    case 'cancelled':
    default:
      return 'text-brand-grey-base'
  }
}
